import { render, staticRenderFns } from "./InstallmentOptionBoxV2.vue?vue&type=template&id=0b1784ca&scoped=true"
import script from "./InstallmentOptionBoxV2.vue?vue&type=script&lang=js"
export * from "./InstallmentOptionBoxV2.vue?vue&type=script&lang=js"
import style0 from "./InstallmentOptionBoxV2.vue?vue&type=style&index=0&id=0b1784ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1784ca",
  null
  
)

export default component.exports